module.exports = __webpack_public_path__ + "static/media/logo-gpc-blue.557cbea4.svg";